import React from 'react';

type Props = {
  error: Error | null;
};
export const ApiErrorMessages = (props: Props) => {
  if (props.error == null) {
    return <></>;
  }

  const msgs: string[] = (props.error as any).response.data.errors || [];

  return (
    <div className="alert alert-danger text-white" role="alert">
      <span className="alert-text text-sm">
        {msgs.map((m, idx) => (
          <React.Fragment key={`err-msg-${idx}`}>
            {idx > 0 && <br />}
            <div
              dangerouslySetInnerHTML={{
                __html: m,
              }}
            />
          </React.Fragment>
        ))}
      </span>
    </div>
  );
};
